import { render, staticRenderFns } from "./BlockSearch.vue?vue&type=template&id=7d51c67e"
import script from "./BlockSearch.vue?vue&type=script&lang=js"
export * from "./BlockSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports